import React, { memo } from 'react';
import { isEqual } from 'src/utils/lodash-alternatives';
import {
  AccordionPanel,
  useAccordionContext,
  useAccordionItemContext,
} from '@reach/accordion';
import cx from 'clsx';
import styles from '../MainNavigation.module.scss';

interface AnimatedAccordionPanelProps {
  children: React.ReactNode;
}

const AnimatedAccordionPanel: React.FC<AnimatedAccordionPanelProps> = memo(
  ({ children }) => {
    let { isExpanded } = useAccordionItemContext();
    let { openPanels } = useAccordionContext();
    const loadingAnimation = isExpanded && openPanels.length > 0;

    return (
      <AccordionPanel
        hidden={false}
        aria-hidden={!isExpanded || undefined}
        className={cx(
          'accordion-panel',
          styles.accordionPanel,
          loadingAnimation ? styles.showPanel : styles.hidePanel
        )}
      >
        {children}
      </AccordionPanel>
    );
  },
  (
    prevProps: AnimatedAccordionPanelProps,
    nextProps: AnimatedAccordionPanelProps
  ) => isEqual(prevProps, nextProps)
);

export default AnimatedAccordionPanel;
